export default "__VITE_ASSET__BxXodhQN__"